import { render, staticRenderFns } from "./fontSize-editor.vue?vue&type=template&id=28a7f4d0&scoped=true&"
import script from "./fontSize-editor.vue?vue&type=script&lang=js&"
export * from "./fontSize-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7f4d0",
  null
  
)

export default component.exports